import React from 'react';
import styled from 'styled-components';
import { TextButton } from '../../../ui/TextButton';
import { useResolve } from '../../Container';
import { PassportModel } from '../../PassportModel';
import { AccountModel } from '../AccountModel';
import { Colors } from './../../../ui';

const Frame = styled.div<{ warn?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: .5rem 3%;
    margin: .5rem;
    border-radius: .5rem;
    background: ${p => p.warn ? Colors.mystery : 'rgba(0,0,0,0.2)'};   
    /* font-weight: 450; */
    user-select: none; 

    ${TextButton} {
        text-decoration: underline;
        color: white;
    }
`;

export const ReadonlySlice = () => {
    const account = useResolve(AccountModel);
    const passport = useResolve(PassportModel);
    if (passport.verify('da:write')) return <></>;
    return <Frame>
        You are a readonly member of {account.label}.  Speak to the account owner for full membership.
    </Frame>;
};
